import { OnInit } from "@angular/core";
import { Subject } from "rxjs";
import { BsModalRef } from "ngx-bootstrap";
import { FormBuilder, Validators } from '@angular/forms';
var JobFocAndAbortComponent = /** @class */ (function () {
    function JobFocAndAbortComponent(sidePanelModalRef, fb) {
        this.sidePanelModalRef = sidePanelModalRef;
        this.fb = fb;
        this.title = '';
        this.labelType = '';
        this.select2Config = {};
    }
    JobFocAndAbortComponent.prototype.ngOnInit = function () {
        this.onClose = new Subject();
        this.select2Config = {
            width: '100%'
        };
        this.jobForm = this.fb.group({
            reason: ['', Validators.required],
            note: ['']
        });
    };
    JobFocAndAbortComponent.prototype.onSubmit = function () {
        this.onClose.next(this.jobForm.value);
        this.sidePanelModalRef.hide();
    };
    return JobFocAndAbortComponent;
}());
export { JobFocAndAbortComponent };
